export default __webpack_public_path__ + "static/media/15788860375e1be395754a3.241e4f32.png";